<template>
  <b-modal
    centered
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container>
      <b-row>
        <b-col>
          <h5 class="text-danger">{{ $t("globals.terminate_order") }}:</h5>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <h6 class="text-secondary">
            {{ "*" + $t("globals.terminate_all_devices_warning") }}
          </h6>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col>
          <label>{{ $t("globals.termination_reason") }}</label>
          <b-form-select
            v-model="reason.selected"
            :options="reason.options"
          />
        </b-col>
      </b-row>
      <b-row v-if="reason.selected === 'other'">
        <b-col>
          <label>{{ $t("globals.other") }}</label>
          <b-form-textarea
            v-model="reason.other_fill"
            rows="3"
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <b-btn size="sm" @click="onClose" variant="warning">
            {{ $t("globals.cancel") }}
          </b-btn>
        </b-col>
        <b-col>
          <b-btn
            size="sm"
            class="float-right"
            variant="danger"
            @click="save"
            :disabled="saveDisabled"
          >
            {{ $t("globals.terminate") }}
          </b-btn>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      reason: {
        selected: null,
        other_fill: "",
        options: []
      }
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleMutation"]),
    ...mapActions("constants", ["fetchActiveEnums"]),
    callFetchEnums() {
      this.fetchActiveEnums({ this_ref: this, enums: ["order_termination_reason"] })
        .then(res => {
          if (res) {
            this.reason.options = res.order_termination_reason;
          }
        });
    },
    onClose() {
      this.reason.selected = null;
      this.reason.other_fill = "";
      this.close();
    },
    save() {
      let data = {
        query: `
          mutation {
            res: OrderTerminate(
              order_id: ${parseInt(this.$route.params.id)},
              reason: "${this.reason.selected}",
              reason_other: "${this.reason.other_fill}"
            )
          }
        `
      };

      this.simpleMutation({ data, this_ref: this, skip_confirm: true }).then(() => {
        this.reason.selected = null;
        this.reason.other_fill = "";
        this.close();
      });
    }
  },
  computed: {
    saveDisabled() {
      return (
        !this.reason.selected ||
        (this.reason.selected === "other" && this.reason.other_fill.length < 2)
      );
    }
  },
  mounted() {
    this.callFetchEnums();
  }
};
</script>
